// assets/custom-facets.js
(function(){
  const form = document.querySelector('form.facets') || document.querySelector('form[action*="/collections"]');
  if(!form) return;

  const contentSelector = (document.querySelector('.collection') && '.collection') || (document.querySelector('.collection-grid') && '.collection-grid') || '.collection';

  async function runAjaxFilter(){
    const fd = new FormData(form);
    if(fd.has('page')) fd.set('page','1');
    const qs = new URLSearchParams(fd).toString();
    const base = form.getAttribute('action') || window.location.pathname;
    const url = base + (qs ? '?' + qs : '');

    const contentEl = document.querySelector(contentSelector);
    if(contentEl) contentEl.classList.add('is-loading');

    try {
      const res = await fetch(url, { credentials: 'same-origin', headers: {'X-Requested-With':'XMLHttpRequest'} });
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newContent = doc.querySelector(contentSelector);
      if(newContent && contentEl) contentEl.innerHTML = newContent.innerHTML;
      history.replaceState({ajaxFilter:true}, '', url);
      // push custom event for GTM (optional)
      if (window.dataLayer) window.dataLayer.push({event:'ajaxFilter', ajaxUrl: url});
    } catch(e){
      console.error('AJAX filter failed', e);
      // fallback: window.location.href = url;
    } finally {
      if(contentEl) contentEl.classList.remove('is-loading');
    }
  }

  // block native submit
  form.addEventListener('submit', function(e){ e.preventDefault(); e.stopImmediatePropagation(); }, true);

  // block programmatic submit
  const origSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function(){
    if(this === form){ setTimeout(runAjaxFilter, 60); return; }
    return origSubmit.apply(this, arguments);
  };

  // intercept clicks & changes inside the form
  form.addEventListener('click', function(e){
    const el = e.target.closest('a,button');
    if(!el) return;
    if(el.tagName === 'A' && el.getAttribute('href') && el.getAttribute('href').includes('/collections')){
      e.preventDefault(); e.stopImmediatePropagation(); runAjaxFilter();
    } else if(el.tagName === 'BUTTON' && (el.type === 'submit' || el.getAttribute('data-action') === 'submit')){
      e.preventDefault(); e.stopImmediatePropagation(); runAjaxFilter();
    }
  }, true);

  form.addEventListener('change', function(e){
    const t = e.target;
    if(!t) return;
    if(t.matches('input[type="checkbox"], input[type="radio"], select')) {
      setTimeout(runAjaxFilter, 120);
    }
  });

})();
